module.exports = __webpack_public_path__ + "img/table.63027416.png";